module.exports = __webpack_public_path__ + "media/winner_full_house_6.f7c035a6.mp3";